var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#FAFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18.4655V25.5336C30 28.1527 28.3619 30 25.7443 30H18.247C15.6295 30 14 28.1527 14 25.5336V18.4655C14 15.8464 15.6381 14 18.247 14H25.7443C28.3619 14 30 15.8464 30 18.4655Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25L17.3696 23.8311C17.8631 23.4093 18.6916 23.4071 19.1897 23.8253L19.9824 24.4797C20.5171 24.921 21.4066 24.8891 21.8912 24.4116L23.8877 22.4469C24.461 21.8824 25.5126 21.8476 26.1405 22.3715L28 23.9238",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19C21 20.1038 20.1035 21 18.9994 21C17.8954 21 17 20.1038 17 19C17 17.8962 17.8954 17 18.9994 17C20.1035 17 21 17.8962 21 19Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploded);
export default __webpack_public_path__ + "static/media/documentUploded.c67ca271954b73a4285aba097943ee5f.svg";
export { ForwardRef as ReactComponent };